import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppComponent } from 'projects/dialog/src/app/app.component';
import { Subject } from 'rxjs';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { CfFeedbackTemplateDialogComponent } from './cf-feedback-template-dialog/cf-feedback-template-dialog.component';
import { CfFeedbackTemplateComponent } from './cf-feedback-template/cf-feedback-template.component';

@Component({
  selector: 'dl-configure-feedback',
  templateUrl: './configure-feedback.component.html',
  styleUrls: ['./configure-feedback.component.scss'],

  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigureFeedbackComponent implements OnInit,AfterViewInit  {
  ischeckforTemplate: boolean;
  public constructor(
    private _QnSbnDataService:QnSbnDataService,
    private changeDetectorRef: ChangeDetectorRef,
    public readonly dialog?: MatDialog
  ){
    this._QnSbnDataService.FeedbackEnabled$.subscribe(
      res =>{
        this.feedbackEnabled = res;
      } 
    ) 
  }
 
  public updateFeedbackOptions: Subject<any> = new Subject<any>();
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public isNewFromTemplate = false;
  public templateColumn = ['dragHandle', 'selectType', 'selectText', 'selectMandatory', 'iconSets'];
  public templateData = [];
  public feedbackEnabled: boolean;
  public feedbackAdded: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  @ViewChild('temp') public cf_feedbacktemplate:CfFeedbackTemplateComponent;
  // @ViewChild(CfFeedbackTemplateComponent)
  //public cf_feedbacktemplate!: CfFeedbackTemplateComponent;

  public ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(observer=>{  
      this.ischeckforTemplate = !observer['template'];
      if(!this._QnSbnDataService.isEmpty(observer['configureFeedback'])){
        this.newFeedbackClicked();
      }
    })
    this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
  }
  ngAfterViewInit(): void {
   // this.cf_feedbacktemplate.ngOnInit();
  }
  public checkAlreadyExistData(templateDatafortable){
    const newFeedbackDataSource = {
      templateData: templateDatafortable,
      placement: 'after'
    };
    this.changeDetectorRef.detectChanges();
    this.updateFeedbackOptions.next(newFeedbackDataSource);
    this.cf_feedbacktemplate.ngOnInit();
  }

  public btnTemplatesClicked(): void {
    // TODO: fetch data from server using API
    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    const tableColumnData = ['dragHandle', 'select', 'selectType', 'selectText', 'selectMandatory', 'iconSets'];
    const templateDataList = [
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Do you agree to it?',
        selectMandatory: 'Mandatory',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Question',
        selectText: 'How are you?',
        selectMandatory: 'Mandatory',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Are you ready?',
        selectMandatory: 'Mandatory',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      }
    ];
    const dialogRef = this.dialog.open(CfFeedbackTemplateDialogComponent, {
      data: { tableData: templateDataList, columnData: tableColumnData },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result.data) {
        return;
      }
      this.isAfoBtnDisabled = false;
      this.isAfoBtnExpanded = false;
      const isNewFeedback = this.templateData.length > 0 ? false : true;
      this.templateColumn = result.data.newColumnData;
      this.templateData = result.data.newTableData;
      const newFeedbackDataSource = {
        templateData: this.templateData,
        placement: 'after'
      };
      if (isNewFeedback) {
        this.changeDetectorRef.detectChanges();
      } else {
        // this.updateFeedbackOptions.next(this.templateData);
        this.updateFeedbackOptions.next(newFeedbackDataSource);
      }
    });
  }

  public btnAfoClicked(): void {
    this.isAfoBtnExpanded = !this.isAfoBtnExpanded;
  }

  public newFeedbackClicked(checkpara?): void {
    if(checkpara == 'clicked'){
     this.isAfoBtnDisabled = true;
      this.isAfoBtnExpanded = false;
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
    }
    
    this.templateData = [
      {
        dragHandle: '',
        selectType: '',
        selectText: '',
        dropDownOpt: [],
        radioOpt: [],
        selectMandatory: '',
        iconSets: 'yes-icon' // value should be 'yes-icon, more-icon, delete-icon'
      }
    ];
    const newFeedbackDataSource = {
      templateData: this.templateData,
      placement: 'after'
    };
    
    this.updateFeedbackOptions.next(newFeedbackDataSource);
  }

  public chooseFromTemplateClicked(): void {
    // this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    this.btnTemplatesClicked();
  }

  public feedbackOptionAdded(isAdded: boolean): void {
    this.isAfoBtnDisabled = !isAdded;
    this._QnSbnDataService.isAfoBtnDisabled$.next(false);
  }

  public onFeedbackAdded(added: boolean) {
    this.feedbackAdded = added;
  }

  public updateFBEnabled(toggle){
     this._QnSbnDataService.isValidFeedback$.subscribe(
      res =>{
        this.isValid = res;
    })
     this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
      res =>{
        this.fbDisabledAndEnabled = res;
      } 
    )

    if(!toggle){
      this._QnSbnDataService.DueDateEnabled$.next(toggle);
      this._QnSbnDataService.isAfoBtnDisabled$.next(false);
      this._QnSbnDataService.isValidFeedback$.next(false);
    }else if (toggle && this.feedbackAdded){
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
      this._QnSbnDataService.FeedbackEnabled$.next(toggle);
    }else if (toggle && !this.fbDisabledAndEnabled && this.isValid && !this.feedbackAdded){
      this._QnSbnDataService.fbDisabledAndEnabled$.next(true);
      this._QnSbnDataService.FeedbackEnabled$.next(toggle);
    }else {
      this._QnSbnDataService.fbDisabledAndEnabled$.next(true);
      this._QnSbnDataService.FeedbackEnabled$.next(toggle);
    }
  }
}
